export const getNumberLengthClass = (value: number | string): string => {
  const numStr = String(value).replace(/\s/g, '');
  const length = numStr.length;
  
  if (length >= 6) return 'length-6-plus';
  if (length === 5) return 'length-5';
  if (length === 4) return 'length-4';
  
  return '';
};
